import { useState } from 'react';

import { fmt } from '@dcc-erp/shared';
import { Icon } from '@dcc-erp/ui';

export interface DisbursePayload {
  payMethod: string;
  disburseAccountCode?: string;
}

const METHODS: { value: string; label: string }[] = [
  { value: 'TRANSFER', label: 'โอนธนาคาร' },
  { value: 'CASH', label: 'เงินสด' },
  { value: 'CHEQUE', label: 'เช็ค' },
];

// Disburse an APPROVED advance — posts the issuance JV (Dr เงินทดรอง / Cr เงินสด).
// SoD is enforced server-side (the final approver cannot disburse).
export function DisburseModal({
  voucherNo,
  amount,
  busy,
  error,
  onConfirm,
  onClose,
}: {
  voucherNo: string;
  amount: number;
  busy: boolean;
  error: string | null;
  onConfirm: (p: DisbursePayload) => void;
  onClose: () => void;
}) {
  const [payMethod, setPayMethod] = useState('TRANSFER');

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,15,20,0.45)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 100,
        padding: 24,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: 12,
          width: 460,
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            padding: '18px 22px',
            borderBottom: '1px solid var(--border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h3
            style={{ margin: 0, fontSize: 18, fontWeight: 600, fontFamily: 'var(--font-display)' }}
          >
            จ่ายเงินทดรอง
          </h3>
          <button className="btn ghost" onClick={onClose} style={{ padding: '0 8px' }}>
            <Icon name="x" size={18} />
          </button>
        </div>

        <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="meta">
            <b className="code">{voucherNo}</b> · จ่ายออก <b className="tnum">{fmt(amount)}</b> บาท
            (Dr เงินทดรอง / Cr เงินสด) — ผู้จ่ายต้องไม่ใช่ผู้อนุมัติขั้นสุดท้าย
          </div>
          <div>
            <label className="meta" style={{ display: 'block', marginBottom: 6 }}>
              วิธีจ่าย
            </label>
            <select
              className="select"
              aria-label="วิธีจ่าย"
              value={payMethod}
              onChange={(e) => setPayMethod(e.target.value)}
              style={{ width: '100%', height: 38 }}
            >
              {METHODS.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>
          {error && (
            <div className="badge negative" style={{ fontSize: 13 }}>
              {error}
            </div>
          )}
        </div>

        <div
          style={{
            padding: '14px 22px',
            borderTop: '1px solid var(--border)',
            background: '#fafafa',
            display: 'flex',
            justifyContent: 'space-between',
            gap: 10,
          }}
        >
          <button className="btn ghost" onClick={onClose}>
            ยกเลิก
          </button>
          <button className="btn primary" disabled={busy} onClick={() => onConfirm({ payMethod })}>
            <Icon name="check" size={14} /> ยืนยันจ่ายเงิน
          </button>
        </div>
      </div>
    </div>
  );
}
